export const calendarMonth_August = "SUyEo";
export default {calendarMonth_August};